import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  paramName: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.element,
  leftIconClick: PropTypes.func,
  rightIcon: PropTypes.element,
  rightIconClick: PropTypes.func
};

var defaultProps = {
  value: ''
};

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.focus = function () {
      _this.input.focus();
    };

    _this.blur = function () {
      if (!_this.state.focus) {
        return;
      }
      _this.setState({ focus: false }, function () {
        return _this.input.blur();
      });
    };

    _this.onFocus = function (e) {
      _this.setState({
        focus: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.onBlur = function (e) {
      _this.setState({
        focus: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur({
          paramName: _this.props.paramName,
          value: _this.props.value
        });
      }
    };

    _this.onSubmit = function (e) {
      e.preventDefault();
      _this.setState({
        lastValue: _this.props.value
      });

      if (_this.props.onSubmit) {
        _this.props.onSubmit({
          paramName: _this.props.paramName,
          value: _this.props.value
        });
      }
    };

    _this.onCancel = function (e) {
      if (_this.props.value !== _this.state.lastValue) {
        _this.onChange(null, _this.state.lastValue);
      }
      if (_this.props.onCancel) {
        _this.props.onCancel(e);
      }
    };

    _this.onChange = function (e, value) {
      if (_this.props.onChange) {
        _this.props.onChange({
          paramName: _this.props.paramName,
          value: e ? e.target.value : value
        });
      }
    };

    _this.onKeyDown = function (e) {
      if (e.keyCode === 13) {
        /* enter keypress */
        _this.blur();
        _this.onSubmit(e);
      } else if (e.keyCode === 27) {
        /* esc keypress */
        _this.blur();
      }
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.state = {
      lastValue: props.value,
      focus: false
    };
    return _this;
  }

  /*
   ** We use handmade shouldComponentUpdate instead of PureComponent in order to ignore the onChange function
   ** it allows us to create a new function on every render in the parent : onChange={() => { doSomething() }}
   ** without rerendering the component everytime the parent is rendered (PureComponent have this side effect )
   */


  _createClass(Input, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onChange', 'onSubmit', 'onFocus', 'onBlur', 'onKeyDown'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }

        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      if (this.state.focus !== nextState.focus) {
        return true;
      }
      return false;
    }

    /* called from outside in TimeInput */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          paramName = _props.paramName,
          onChange = _props.onChange,
          value = _props.value,
          leftIcon = _props.leftIcon,
          rightIcon = _props.rightIcon,
          leftIconClick = _props.leftIconClick,
          rightIconClick = _props.rightIconClick,
          props = _objectWithoutProperties(_props, ['className', 'paramName', 'onChange', 'value', 'leftIcon', 'rightIcon', 'leftIconClick', 'rightIconClick']);

      var focus = this.state.focus;


      return React.createElement(
        'div',
        { className: 'gp-input' },
        leftIcon && React.createElement(
          'span',
          { className: 'left-icon' + (leftIconClick ? ' pointer' : ''), onClick: leftIconClick },
          leftIcon
        ),
        React.createElement('input', _extends({}, props, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          autoFocus: true,
          onKeyDown: this.onKeyDown,
          onChange: this.onChange,
          onBlur: function onBlur() {
            _this2.onBlur();
          },
          onFocus: this.onFocus,
          className: (focus ? 'focus ' : '') + (leftIcon ? 'left-icon ' : '') + (rightIcon ? 'right-icon ' : '') + (className ? '' + className : ''),
          value: this.props.value,
          autoComplete: 'new-password' // we don't want the chrome auto-fill feature
        })),
        rightIcon && React.createElement(
          'span',
          { className: 'right-icon' + (rightIconClick ? ' pointer' : ''), onClick: rightIconClick },
          rightIcon
        )
      );
    }
  }]);

  return Input;
}(Component);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export default Input;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Input/index.js
// module id = 822
// module chunks = 0